import { Flex } from 'components/shared/flex'
import { usePostEquipmentCategoryApi, usePutEquipmentCategoryApi } from 'api/equipment_category'
import { InputField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { EquipmentCategory, EquipmentCategoryForm } from 'entities/equipment_category'

export type FormViewProps = {
    form: Form<EquipmentCategoryForm>
    apiError: ApiError
}

const FormView = ({ form, apiError }: FormViewProps) => {
    return (
        <>
            <Flex>
                <InputField form={form} attr="name" apiError={apiError} label="機器分類" placeholder="遠心分離機" required />
                <InputField
                    form={form}
                    attr="code"
                    apiError={apiError}
                    label="記録書番号"
                    required
                    hint={
                        <div>
                            <div>機器に紐づく記録書番号を登録してください</div>
                            <div>例）LFRM-RCL00001 → 『RCL00001』を入力</div>
                        </div>
                    }
                />
            </Flex>
        </>
    )
}

type NewEquipmentCategoryFormProps = {
    onComplete?: () => void
}

export const NewEquipmentCategoryForm = (props: NewEquipmentCategoryFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostEquipmentCategoryApi()
    const form = useForm<EquipmentCategoryForm>({})
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                機器カテゴリー登録
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>機器カテゴリーの登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <FormView form={form} apiError={api.apiError} />
                    </>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
type EditEquipmentCategoryFormProps = {
    equipmentCategory: EquipmentCategory
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditEquipmentCategoryForm = (props: EditEquipmentCategoryFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutEquipmentCategoryApi()
    const form = useForm<EquipmentCategoryForm>(props.equipmentCategory)

    useEffectSkipFirst(() => {
        form.set(props.equipmentCategory)
    }, [props.equipmentCategory])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>機器カテゴリーの編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>{form.object.id && <FormView form={form} apiError={api.apiError} />}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
